module.exports = __webpack_public_path__ + "static/media/5.9e209362.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/5.png
// module id = 784
// module chunks = 0